import React from 'react';
import { Tooltip } from 'antd';

/**
 * 航线实例括号可视化组件
 * 模仿 RotationVisualizer，用竖线/U型括号把同一实例的航段圈起来
 *
 * @param {string} position - "start" | "middle" | "end" | "single" | "none"
 * @param {string} color - 括号颜色
 * @param {string} tooltip - hover 提示
 * @param {number|string} label - 括号中间显示的文字
 */
const RouteInstanceBracket = ({ position = 'none', color = '#1890ff', tooltip, label }) => {
    if (position === 'none') return <span style={{ display: 'inline-block', width: 20 }} />;

    const HEIGHT = 42;
    const BAR_W = 18;

    let containerStyle = {
        height: HEIGHT,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
    };

    let borderStyle = {};

    if (position === 'single') {
        borderStyle = {
            border: `2px solid ${color}`,
            width: BAR_W,
            height: 24,
            borderRadius: 4,
        };
    } else if (position === 'start') {
        containerStyle.justifyContent = 'flex-end';
        borderStyle = {
            borderLeft: `2px solid ${color}`,
            borderTop: `2px solid ${color}`,
            borderRight: `2px solid ${color}`,
            borderBottom: 'none',
            width: BAR_W,
            height: 36,
            borderRadius: '4px 4px 0 0',
        };
    } else if (position === 'end') {
        containerStyle.justifyContent = 'flex-start';
        borderStyle = {
            borderLeft: `2px solid ${color}`,
            borderBottom: `2px solid ${color}`,
            borderRight: `2px solid ${color}`,
            borderTop: 'none',
            width: BAR_W,
            height: 36,
            borderRadius: '0 0 4px 4px',
        };
    } else {
        borderStyle = {
            borderLeft: `2px solid ${color}`,
            borderRight: `2px solid ${color}`,
            borderTop: 'none',
            borderBottom: 'none',
            width: BAR_W,
            height: '100%',
            position: 'absolute',
        };
    }

    const content = (
        <div style={{ textAlign: 'center' }}>
            <div style={containerStyle}>
                <div style={borderStyle} />
                {label != null && (
                    <span style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: 10,
                        fontWeight: 'bold',
                        color,
                    }}>
                        {label}
                    </span>
                )}
            </div>
        </div>
    );

    if (tooltip) {
        return <Tooltip title={tooltip} mouseEnterDelay={0.5} placement="right">{content}</Tooltip>;
    }
    return content;
};

export default RouteInstanceBracket;
